import { Colors } from '../Colors';

const coloredDropdown = {
    color: Colors.white,
    cursor: 'pointer',
    border: 'none',
};

const help = {
    dropdown: {
        backgroundColor: Colors.mystery,
        ...coloredDropdown,
    }
};

const info = {
    dropdown: {
        backgroundColor: Colors.primaryLight,
        ...coloredDropdown,
    }
};

const warning = {
    dropdown: {
        backgroundColor: Colors.observe,
        ...coloredDropdown,
    }
};

const vars = {
    info, warning, help,
};

export default {
    styles: (_, { variant }) => {
        return vars[variant] ?? {};
    },
};
